import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

export interface SearchResultState {
    firmResult: any
}

const initialState: SearchResultState = {
    firmResult: {}
};

export const searchResultSlice = createSlice({
    name: 'searchResult',
    initialState,
    reducers: {
        setFirmResult: (state: SearchResultState, action) => {
            state.firmResult = action.payload;
        }
    }
})

export const { setFirmResult } = searchResultSlice.actions;
export const firmResult = (state: RootState) => state.searchResult.firmResult;
export default searchResultSlice.reducer;